import React from 'react';
import { Logo, NamedLink } from '../../../components';
import officeLounge from '../../../assets/homepage/office-lounge.webp';
import SignupIcon from './SignupIcon';
import css from './SignupForm.module.css';

export const isAdvertiser = config =>
  config?.roles?.provider === true || config?.userType === 'provider';

export default function SignupLayout({ children, userTypeConfig }) {
  const advertiser = isAdvertiser(userTypeConfig);
  const benefits = advertiser
    ? [
        'Présentez vos espaces à louer ou à vendre',
        'Personnalisez votre vitrine',
        'Échangez avec les entreprises',
      ]
    : [
        'Gardez vos coups de cœur',
        'Comparez les espaces qui vous plaisent',
        'Échangez avec les annonceurs',
      ];
  return (
    <div className={css.page}>
      <a className={css.skip} href="#signup-main">
        Aller au formulaire
      </a>
      <header className={css.siteHeader}>
        <NamedLink name="LandingPage" className={css.brand} aria-label="Cobuco, accueil">
          <Logo layout="desktop" />
        </NamedLink>
        <NamedLink name="NosAnnonces2Page" className={css.backLink}>
          <SignupIcon name="arrow" />
          Retour aux annonces
        </NamedLink>
      </header>
      <main className={css.signupLayout}>
        <aside className={css.story} aria-label="Bienvenue dans l’univers Cobuco">
          <img
            className={css.storyImage}
            src={officeLounge}
            width="1536"
            height="1024"
            alt="Bureau lumineux avec salon et espaces de travail"
          />
          <div className={css.storyShade} />
          <p className={css.storyEyebrow}>
            <span />
            L’immobilier professionnel, simplement.
          </p>
          <div className={css.storyCopy}>
            <p className={css.storyHeading}>
              Un espace.
              <br />
              <span>Des possibilités.</span>
            </p>
            <p className={css.storyDescription}>
              De belles adresses, de nouvelles rencontres.
              <br />
              Et la prochaine étape de votre projet.
            </p>
            <div className={css.storyDivider} />
            <ul className={css.benefits}>
              {benefits.map((text, i) => (
                <li key={text}>
                  <SignupIcon name={['heart', 'grid', 'message'][i]} />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className={css.storyBottom}>
            <span>À louer. À acheter. À vous de choisir.</span>
            <span className={css.storyMonogram} aria-hidden="true">
              c.
            </span>
          </div>
        </aside>
        <section className={css.formPanel} id="signup-main" aria-labelledby="signup-heading">
          <div className={css.formContent}>{children}</div>
          <p className={css.formSignature}>Le bon espace. La bonne rencontre.</p>
        </section>
      </main>
      <footer className={css.footer}>
        <span>© Cobuco</span>
        <nav aria-label="Informations légales">
          <NamedLink name="PrivacyPolicyPage" target="_blank" rel="noopener noreferrer">
            Confidentialité
          </NamedLink>
          <NamedLink name="TermsOfServicePage" target="_blank" rel="noopener noreferrer">
            Conditions d’utilisation
          </NamedLink>
          <a href="mailto:norman@cobuco.fr">Besoin d’aide ?</a>
        </nav>
      </footer>
    </div>
  );
}
